import * as React from "react"

export const PathwayViewer = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="-1 -2 25.4 17.58"
        xmlSpace="preserve"
        width="1em" height="1em" fill="currentColor"
    >
        <path
            d="M12.57 7.69h.26a2.172 2.172 0 0 0 2.05-2.17c0-.4-.11-.78-.31-1.11a2.168 2.168 0 0 0-3.82.15c-.14.29-.22.61-.22.95 0 1.17.9 2.12 2.04 2.18zM16.28 11.29c-.36-.52-.84-.97-1.39-1.29-.61-.36-1.31-.57-2.06-.59h-.26c-.7.02-1.36.21-1.95.53-.61.33-1.14.81-1.53 1.39a4.366 4.366 0 0 0-.76 2.45v.26c0 .78.64 1.42 1.41 1.42h2.8c.1.01.2.01.3.01s.2-.01.3-.01h2.5c.78 0 1.42-.64 1.42-1.42v-.26c0-.16-.01-.33-.03-.49-.08-.74-.34-1.42-.75-2zM22.73 13.94h-1.15c-1.06 0-1.91-1.12-1.91-2.51v0c0-1.39-.86-2.51-1.91-2.51h-.02M22.73 3.68h-1.15c-1.06 0-1.91 1.12-1.91 2.51v0c0 1.39-.86 2.51-1.91 2.51h-.02"
        />
        <path
            d="m21.99 5.65 1.72-1.72a.38.38 0 0 0 0-.54l-1.72-1.72M21.99 15.91l1.72-1.72a.38.38 0 0 0 0-.54l-1.72-1.72M2.67 3.64h1.15c1.06 0 1.91 1.12 1.91 2.51v0c0 1.39.86 2.51 1.91 2.51h.02M2.67 13.89h1.15c1.06 0 1.91-1.12 1.91-2.51v0c0-1.39.86-2.51 1.91-2.51h.02"
        />
        <path
            d="m3.41 11.93-1.72 1.72a.38.38 0 0 0 0 .54l1.72 1.72M3.41 1.66 1.69 3.38a.38.38 0 0 0 0 .54l1.72 1.72"
        />
    </svg>
)

